import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, GroupCreationDialogueHandler } from '../types';
import GroupCreationDialogueContext from './CreateGroupContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type GroupCreationDialogueProps = {
  handleDialogue: DialogueHandler<GroupCreationDialogueHandler>;
};

type FC = FunctionComponent<GroupCreationDialogueProps>;

const GroupCreationDialogue: FC = ({ handleDialogue }: GroupCreationDialogueProps) => {
  const { showGroupCreationErrorAlert, groupCreationError } = useContext(GroupCreationDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Create.GroupCreationErrorDialog' });

  return useMemo(
    () => (
      <div>
        {/* Group Creation Error */}
        <ConfirmationDialogue
          isVisible={showGroupCreationErrorAlert}
          title={t('title')}
          status="error"
          subTitle={`${groupCreationError}`}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showGroupCreationErrorAlert, groupCreationError],
  );
};

export default GroupCreationDialogue;
